interface BrandProps {
  readonly compact?: boolean;
  readonly inverse?: boolean;
}

/** Product identity shared by the console shell and authentication page. */
export function Brand({ compact = false, inverse = false }: BrandProps) {
  return (
    <div className={`brand ${compact ? "brand-compact" : ""} ${inverse ? "brand-inverse" : ""}`.trim()}>
      <span className="brand-mark" aria-hidden="true"><span>S</span></span>
      <span className="brand-copy">
        <strong>SONOX</strong>
        <small>IM 开放平台</small>
      </span>
    </div>
  );
}
